import { createApp } from 'vue'
import './composables/bootLoader'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './styles/bet-night.css'
import './styles/bet-page-shell.css'
import { ensureLgwSession } from './api/session'
import { visibilityEpoch } from './data/games'

async function boot () {
  // 先准备会话（兑 SSO / 清过期 token），再挂载，避免首屏刷一串 401
  try {
    await ensureLgwSession()
    visibilityEpoch.value += 1
  } catch (err) {
    console.warn('[sso]', err?.message || err)
  }

  const app = createApp(App)
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
  app.use(ElementPlus).use(router).mount('#app')
}

boot()
